import { render, staticRenderFns } from "./new-object.vue?vue&type=template&id=c1de47a6"
import script from "./new-object.vue?vue&type=script&lang=js"
export * from "./new-object.vue?vue&type=script&lang=js"
import style0 from "./new-object.vue?vue&type=style&index=0&id=c1de47a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports